import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { Grid, Button } from "@material-ui/core";

import { useEffect } from "react";
import { getButtonPointAccesss } from "../../repositories/buttonPointAccessRepository";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import { useContext } from "react";
import { PointAccessContext } from "../../context/PointAccessContext";
import SearchInput from "../../components/basic/SearchInput";
import filterTable from "../../utils/filterTable";
import "./.pointAccess.css";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function ModalButtons() {
  const [buttons, setButtons] = useState([]);
  const [allButtons, setAllButtons] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    files,
    openModalButtons: open,
    handleCloseModalButtons,
    indexImageSelectToButtons,
    handleSelectButton,
  } = useContext(PointAccessContext);
  const classes = useStyles();

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const { data } = await getButtonPointAccesss();

        if (data.success) {
          setButtons(data.data);
          setAllButtons(data.data);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getData();
  }, []);

  const handleChangeFilter = (e) => {
    if (!e || !e.target.value) return setButtons(allButtons);

    const newArr = filterTable({
      data: allButtons,
      text: e.target.value,
      columns: ["Nome", "Funcao"],
    });

    setButtons(newArr);
  };

  return (
    <div>
      {loading && open && <ModalLoading loading={loading} />}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={
          open && (indexImageSelectToButtons || indexImageSelectToButtons === 0)
            ? true
            : false
        }
        onClose={handleCloseModalButtons}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Grid
          container
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={8}
          sm={10}
          xs={11}
          id="modal"
        >
          <Grid item xs={12} container alignItems="center" justify="center">
            <label className="title">Botões</label>
          </Grid>

          <Grid item xs={11} container alignItems="center" justify="center">
            <SearchInput
              placeholder="Pesquisar"
              handleChange={handleChangeFilter}
            />
          </Grid>

          <Grid
            item
            xs={11}
            container
            alignItems="center"
            justify="flex-start"
            spacing={1}
          >
            {buttons.map((btn, index) => (
              <Grid
                item
                lg={2}
                md={3}
                sm={3}
                xs={4}
                key={index}
                container
                justify="center"
              >
                <label>{btn.Funcao}</label>
                <Button
                  style={{
                    textTransform: "none",
                    outline: "none",
                    background: btn.Cor,
                    color: btn.CorTexto,
                    border:
                      files[indexImageSelectToButtons] &&
                      files[indexImageSelectToButtons].buttons
                        ? files[indexImageSelectToButtons].buttons.includes(
                            btn.Id
                          )
                          ? "solid #8bc34a 3px"
                          : ""
                        : "",
                    width: "100%",
                  }}
                  onClick={() =>
                    handleSelectButton(btn.Id, indexImageSelectToButtons)
                  }
                >
                  {btn.Nome}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
}
